import _ from 'lodash';

import { mapGetters, mapActions } from 'vuex';

/**
 * Base test data
 *
 * @type  {Object}
 */
const baseTestData = {
    disabled: false,
    defaultValue: false,
    placeholder: 'test placeholder',
    id: 'testId',
    name: 'testName',
    value: null,
    required: false,
    label: 'Test Label',
    mutation: 'testing/DEFAULT_TEST_MUTATION',
    tooltip: 'Testing the Tooltip.',
    vueComponent: 'Textarea',
};
export default {
    data() {
        return {
            /**
             * An object sent to child components; used to signal that the fields need to be reset, with the ability
             * to limit the reset to only certain fields
             *
             * @type  {Object}
             */
            formFieldsReset: {
                /**
                 * A list of field names to include in a reset action
                 *
                 * @type  {Array}
                 */
                includeFields: [],

                /**
                 * A parameter that is listened by the child components. Changed via moment().valueOf() method to always
                 * set the fresh value.
                 *
                 * @type  {integer}
                 */
                resetData: null,
            },

            /**
             * Tests
             *
             * @type  {Object}
             */
            tests: {
                testDefaultSettings: {
                    ...baseTestData,
                },

                testDisabled: {
                    ...baseTestData,
                    disabled: true,
                },

                testValue: {
                    ...baseTestData,
                    value: 'test123',
                },

                testRequired: {
                    ...baseTestData,
                    required: true,
                },

                testDefaultValue: {
                    ...baseTestData,
                    defaultValue: 'test123',
                },
            },

            /**
             * Selected test data
             *
             * @type  {Object}
             */
            test: {},
        };
    },

    // methods: {
    //     ...mapActions('admin', [
    //         'changeEditorMode',
    //     ])
    // },

    /**
     * Set the computed property
     *
     * @type  {Object}
     */
    computed: {
        ...mapGetters({
            testingState: 'testing/testing',
        }),

        /**
         * Toggles the tested component
         *
         * @return  {boolean}
         */
        showComponent() {
            return !_.isEmpty(this.test);
        },
    },

    // beforeCreate() {
    //     this.changeEditorMode({newEditorMode: 'create'});
    // },
    // created() {
    //     this.changeEditorMode({newEditorMode: 'create'});
    // },

    /**
     * Set the mounted hook
     *
     * @return  {void}
     */
    mounted() {
        // this.changeEditorMode({newEditorMode: 'create'});
        this.test = this.tests[this.$route.params.test];
    },
};
